import React from 'react'

function OtherLinks() {
  return (
    <div className='container'>OtherLinks</div>
  )
}

export default OtherLinks;